import script from "./AppMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AppMenu.vue?vue&type=style&index=0&id=67593392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67593392"]])

export default __exports__